const POST = 'POST'
const GET = 'GET'
const DELETE = 'DELETE'
const PUT = 'PUT'

const RemoveUser = (id) => {
  return {
    method: DELETE,
    url: `/user/${id}`,
    useAuth: true,
  }
}
const ActiveUser = (id) => {
  return {
    method: PUT,
    url: `/user/${id}`,
    useAuth: true,
  }
}

export default {
  Login: { method: POST, url: '/user/login', useAuth: false },

  GetRoles: { method: GET, url: '/roles', useAuth: true },
  CreateRoles: { method: POST, url: '/roles', useAuth: true },

  GetUserWithRoles: { method: GET, url: '/user/get-users', useAuth: true },
  CreateUser: { method: POST, url: '/user/create', useAuth: true },
  RemoveUser,
  ActiveUser,

  GetPermissions: { method: GET, url: '/permissions', useAuth: true },
  CreatePermissions: { method: POST, url: '/permissions', useAuth: true },

  GetJunctionAndArea: {
    method: POST,
    url: '/junction/get/area',
    useAuth: true,
  },

  GetAllJunctions: {
    method: POST,
    url: '/junction/get/all',
    useAuth: true,
  },

  GetAllStates: {
    method: POST,
    url: '/common/get/all-state',
    useAuth: true,
  },

  GetAllCountries: {
    method: POST,
    url: '/common/get/all-country',
    useAuth: true,
  },

  GetAllZones: {
    method: POST,
    url: '/zone/get/all',
    useAuth: true,
  },

  GetAllJunctionAccess: {
    method: POST,
    url: '/user/access/all',
    useAuth: true,
  },

  GetJunctionClock: {
    method: POST,
    url: '/junction/sync/get-rtc',
    useAuth: true,
  },

  SetJunctionClock: {
    method: POST,
    url: '/junction/sync/set-rtc',
    useAuth: true,
  },

  GetSystemGeneralSetting: {
    method: POST,
    url: '/junction/get/config',
    useAuth: true,
  },

  SetNightFlashSetting: {
    method: POST,
    url: '/junction/set/night-flash',
    useAuth: true,
  },
  SetStreetLightSetting: {
    method: POST,
    url: '/junction/set/street-light',
    useAuth: true,
  },
  SetSystemGeneralSetting: {
    method: POST,
    url: '/junction/set/gen-config',
    useAuth: true,
  },

  SetFaultSetting: {
    method: POST,
    url: '/junction/set/fault-config',
    useAuth: true,
  },
  SetGenTimeSetting: {
    method: POST,
    url: '/junction/set/gen-time',
    useAuth: true,
  },

  SetAdminConfig: {
    method: POST,
    url: '/junction/set/admin-config',
    useAuth: true,
  },

  GetCountdownMode: {
    method: POST,
    url: '/traffic-timer/get/countdown',
    useAuth: true,
  },

  SetCountdownMode: {
    method: POST,
    url: '/traffic-timer/set/countdown-config',
    useAuth: true,
  },

  SetMultiplier: {
    method: POST,
    url: '/traffic-timer/set/countdown-multiplier',
    useAuth: true,
  },

  SetCountdownTime: {
    method: POST,
    url: '/traffic-timer/set/countdown-time',
    useAuth: true,
  },

  SetCountdownSetting: {
    method: POST,
    url: '/traffic-timer/set/countdown',
    useAuth: true,
  },

  GetPhaseFlow: {
    method: POST,
    url: '/groups/get/phase-flow',
    useAuth: true,
  },

  SetPhaseFlow: {
    method: POST,
    url: '/groups/set/phase-flow',
    useAuth: true,
  },

  GetSignalOutput: {
    method: POST,
    url: '/groups/get/signal-output',
    useAuth: true,
  },

  GetPhaseDemand: {
    method: POST,
    url: '/detection/get/phase-demand',
    useAuth: true,
  },

  SetPhaseDemand: {
    method: POST,
    url: '/detection/set/channel-config',
    useAuth: true,
  },

  SetPushButton: {
    method: POST,
    url: '/detection/set/pushbutton-config',
    useAuth: true,
  },

  GetPhaseConfig: {
    method: POST,
    url: '/junction/get/phase-config',
    useAuth: true,
  },

  SetPhaseConfig: {
    method: POST,
    url: '/junction/set/phase-config',
    useAuth: true,
  },

  GetFromServer: {
    method: POST,
    url: '/junction/sync/download',
    useAuth: true,
  },

  UpdateToServer: {
    method: POST,
    url: '/junction/sync/update',
    useAuth: true,
  },

  GetSystemInput: {
    method: POST,
    url: '/detection/get/system-inputs',
    useAuth: true,
  },

  SetSystemInput: {
    method: POST,
    url: '/detection/set/system-inputs',
    useAuth: true,
  },

  SetSystemInput: {
    method: POST,
    url: '/detection/set/system-inputs',
    useAuth: true,
  },

  SetLoopDemand: {
    method: POST,
    url: '/detection/set/loop-demand',
    useAuth: true,
  },

  GetXaitsLink: {
    method: POST,
    url: '/link/get/xaits-link',
    useAuth: true,
  },

  SetXaitsLink: {
    method: POST,
    url: '/link/set/xaits-junction-link-config',
    useAuth: true,
  },
  GetGoGreen: {
    method: POST,
    url: '/link/get/go-green-config',
    useAuth: true,
  },

  SetGoGreen: {
    method: POST,
    url: '/link/set/go-green-config',
    useAuth: true,
  },

  GetTransmitLocking: {
    method: POST,
    url: '/link/get/link-signal-config',
    useAuth: true,
  },

  SetTransmitLocking: {
    method: POST,
    url: '/link/set/link-signal-config',
    useAuth: true,
  },

  GetForcing: {
    method: POST,
    url: '/link/get/force-signal-config',
    useAuth: true,
  },

  SetForcing: {
    method: POST,
    url: '/link/set/force-signal-config',
    useAuth: true,
  },

  GetForcePhase: {
    method: POST,
    url: '/link/get/force-phase-config',
    useAuth: true,
  },

  SetForcePhase: {
    method: POST,
    url: '/link/set/force-phase-config',
    useAuth: true,
  },

  GetLinkTimeWindows: {
    method: POST,
    url: '/link/get/time-config',
    useAuth: true,
  },

  SetLinkTimeWindows: {
    method: POST,
    url: '/link/set/time-config',
    useAuth: true,
  },

  GetVaTime: {
    method: POST,
    url: '/time-config/get/va-time',
    useAuth: true,
  },
  SetVaTime: {
    method: POST,
    url: '/time-config/set/va-time',
    useAuth: true,
  },

  GetFixTime: {
    method: POST,
    url: '/time-config/get/mp-time',
    useAuth: true,
  },

  SetFixTime: {
    method: POST,
    url: '/time-config/set/mp-time',
    useAuth: true,
  },
  SetPlanConfig: {
    method: POST,
    url: '/time-config/set/plan-config',
    useAuth: true,
  },

  SetTimeSlots: {
    method: POST,
    url: '/time-config/set/time-slot',
    useAuth: true,
  },

  GetMaxTime: {
    method: POST,
    url: '/time-config/get/va-max-time',
    useAuth: true,
  },
  SetMaxTime: {
    method: POST,
    url: '/time-config/set/va-max-time',
    useAuth: true,
  },
  GetGapTime: {
    method: POST,
    url: '/time-config/get/va-gap-time',
    useAuth: true,
  },
  SetGapTime: {
    method: POST,
    url: '/time-config/set/va-gap-time',
    useAuth: true,
  },
  GetMinTime: {
    method: POST,
    url: '/time-config/get/va-min-time',
    useAuth: true,
  },
  SetMinTime: {
    method: POST,
    url: '/time-config/set/va-min-time',
    useAuth: true,
  },

  GetLiveStatus: {
    method: POST,
    url: '/junction/get/live-overview',
    useAuth: true,
  },

  GetPhaseAggregationByCycle: {
    method: POST,
    url: '/contemp-status/get/avg/bycycles',
    useAuth: true,
  },

  GetPhaseAggregationByTime: {
    method: POST,
    url: '/contemp-status/get/avg/bytime',
    useAuth: true,
  },

  GetTrafficMagnitudeByTime: {
    method: POST,
    url: '/contemp-status/get/veh-vol/bytime',
    useAuth: true,
  },

  GetContempVehVolPhaseByCycle: {
    method: POST,
    url: `/contemp-status/get/veh-vol/bycycles`,
    useAuth: true,
  },

  GetContempGreenTimePhaseByCycle: {
    method: POST,
    url: `/contemp-status/get/green-time/bycycles`,
    useAuth: true,
  },

  GetContempWaitingTimePhaseByCycle: {
    method: POST,
    url: `/contemp-status/get/waiting-time/bycycles`,
    useAuth: true,
  },

  GetContempVehVolPhaseByTime: {
    method: POST,
    url: `/contemp-status/get/veh-vol/bytime`,
    useAuth: true,
  },

  GetContempGreenTimePhaseByTime: {
    method: POST,
    url: `/contemp-status/get/green-time/bytime`,
    useAuth: true,
  },

  GetContempWaitingTimePhaseByTime: {
    method: POST,
    url: `/contemp-status/get/waiting-time/bytime`,
    useAuth: true,
  },

  GetGreenTimeCycleDays: {
    method: POST,
    url: `/green-time/get/bycycle/bydays`,
    useAuth: true,
  },

  GetGreenTimeCycleDates: {
    method: POST,
    url: `/green-time/get/bycycle/bydate`,
    useAuth: true,
  },

  GetGreenTimePhaseDays: {
    method: POST,
    url: `/green-time/get/byphase/bydays`,
    useAuth: true,
  },

  GetGreenTimePhaseDates: {
    method: POST,
    url: `/green-time/get/byphase/bydate`,
    useAuth: true,
  },

  GetVehTimePhaseDays: {
    method: POST,
    url: `/veh-volume/get/byphase/bydays`,
    useAuth: true,
  },

  GetVehTimePhaseDates: {
    method: POST,
    url: `/veh-volume/get/byphase/bydate`,
    useAuth: true,
  },

  GetVehTimeCycleDates: {
    method: POST,
    url: `/veh-volume/get/bycycle/bydate`,
    useAuth: true,
  },

  GetVehTimeCycleDays: {
    method: POST,
    url: `/veh-volume/get/bycycle/bydays`,
    useAuth: true,
  },
  GetRecentAlarms: {
    method: POST,
    url: `/alarms/get/recent`,
    useAuth: true,
  },
  GetAlarmsByDate: {
    method: POST,
    url: `/alarms/get/bydate`,
    useAuth: true,
  },

  GetAlertGroup: {
    method: POST,
    url: `/alarms/get/all-wa-alert-group`,
    useAuth: true,
  },

  SetAlertGroup: {
    method: POST,
    url: `/alarms/set/wa-alert-group`,
    useAuth: true,
  },

  GetSingleAlertGroup: {
    method: POST,
    url: `/alarms/get/wa-alert-group`,
    useAuth: true,
  },

  UpdateAlertGroup: {
    method: POST,
    url: `/alarms/set/wa-alert-group`,
    useAuth: true,
  },

  CreateAlertGroup: {
    method: POST,
    url: `/alarms/new/wa-alert-group`,
    useAuth: true,
  },
  DeleteAlertGroup: {
    method: POST,
    url: `/alarms/remove/wa-alert-group`,
    useAuth: true,
  },
  GetRtsp: {
    method: POST,
    url: `/cctv/get/cctv`,
    useAuth: true,
  },
}
